/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {ServiceProviderInfo} from './service-provider-info.model';
import {ClientInfo} from './client-info.model';
import {AddressInfo} from './address-info.model';
import {InvoiceOrderDTO} from './invoice-order-dto.model';
import {InvoiceGroupedVatItemDTO} from "./invoice-grouped-vat-item-dto.model";
import {InvoiceExchangeRateDTO} from "../invoice-exchange-rate-dto.model";
import { BaseAttachmentDTO } from '@well/attachment/domain';
import { InvoiceState } from './invoice-state.model';
import { InvoiceStatusType } from './invoice-status-type';

export class InvoiceDTO extends JSONable {
  uuid: string | undefined = undefined;
  invoiceSeries: string | undefined = undefined;
  issueDate: string | undefined = undefined;
  serviceProviderInfo: ServiceProviderInfo | undefined = undefined;
  clientInfo: ClientInfo | undefined = undefined;
  billingAddress: AddressInfo | undefined = undefined;
  correspondenceAddress: AddressInfo | undefined = undefined;
  invoiceStatus: InvoiceStatusType | undefined = undefined;
  paymentTimeLimit: number | undefined = undefined;
  paymentDueDate: string | undefined = undefined;

  currencyCode: string | undefined = undefined;
  totalNetAmount: number | undefined = undefined;
  totalVATAmount: number | undefined = undefined;
  totalAmount: number | undefined = undefined;

  localCurrencyCode: string | undefined = undefined;
  localCurrencyTotalNetAmount: number | undefined = undefined;
  localCurrencyTotalVATAmount: number | undefined = undefined;
  localCurrencyTotalAmount: number | undefined = undefined;

  invoiceOrderDtos: InvoiceOrderDTO[] | undefined = undefined;
  invoiceGroupedVATItemDTOS: InvoiceGroupedVatItemDTO[] | undefined = undefined;

  attachmentSaveLocation: string | undefined = undefined;
  invoiceFileStoreUuid: string | undefined = undefined;

  invoiceExchangeRateDTOs: InvoiceExchangeRateDTO[] | undefined = undefined;
  canceledInvoiceDto: InvoiceDTO | undefined = undefined;
  comment: string | undefined = undefined;
  language: string | undefined = undefined;

  customPaymentAgreement: boolean | undefined = undefined;
  invoiceGenerationType: string | undefined = undefined;
  attachmentUuids: string[] = [];
  attachments: BaseAttachmentDTO[] = [];

  state: InvoiceState | undefined = undefined;
}
